var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"cover-wrapper"},[_c('div',{staticClass:"check-letter",on:{"click":function($event){return _vm.checkLetter()}}},[_c('img',{staticClass:"check-img",staticStyle:{"width":"100%"},attrs:{"src":require("../../assets/images/activity/thanksLetter/cover-check.png")}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }